import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './features/Cart/cartSlice';
import siteReducer from './features/Site/siteSlice';

export const store = configureStore({
    reducer: {
        cart: cartReducer,
        site: siteReducer,
    },
})